export function switch_(ctx) {
    return {
        // No per-state overrides: firmware's pretty/pretty_color/sw_knob styles
        // (lv_theme_hasp.c) only ever set LV_STATE_DEFAULT for switch's 3 parts.
        styles: {
            main:      { bg_color: ctx.COLOR_BG_SEC, bg_opa: 255, radius: 999, border_width: 0 },  // #d4d7d9 track
            indicator: { bg_color: ctx.primary, radius: 999 },
            knob:      { bg_color: '#ffffff', radius: 999, border_width: 0 },  // sw_knob = LV_COLOR_WHITE (always white)
        },
    };
}
